// ABOUTME: TipTap extension that resets font weight and size on Enter.
// ABOUTME: Keeps color intact but resets weight to normal and size to normal.

import { Extension } from "@tiptap/core";

const ResetStylesOnEnter = Extension.create({
    name: "resetStylesOnEnter",

    addKeyboardShortcuts() {
        return {
            Enter: ({ editor }) => {
                // Let the default Enter behavior happen first
                const result = editor.commands.splitBlock();

                // Then reset weight and size to normal
                editor.chain().setFontWeight("normal").setFontSize("normal").run();

                return result;
            },
        };
    },
});

export default ResetStylesOnEnter;
